<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <base-crud
          :ref="'checklistSchedulesCrud'"
          crudName="Agendamentos"
          newText="Novo Agendamento"
          :table="table"
          :columns="columns"
          :options="options"
          :endPoint="endPoint"
          :enableAdd="true"
          :enableEdit="true"
          :enableDelete="true"
          :enableView="false"
          :enableReset="false"
          :dataForm="dataForm"
        >
        </base-crud>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../../layouts/Base/BaseCrud";

export default {
  components: {
    BaseCrud,
  },

  data() {
    return {
      table: "checklistSchedulesTable",
      columns: [
        "id",
        "group_name",
        "checklist_name",
        "tipo_recorrencia",
        "status",
        "actions",
      ],
      tableData: [
        "id",
        "group_name",
        "checklist_name",
        "tipo_recorrencia",
        "status",
      ],
      options: {
        filterByColumn: true,
        debounce: 1000,
        filterable: [
          "id",
          "group_name",
          "checklist_name",
          "tipo_recorrencia",
          "status",
        ],
        sortable: [
          "id",
          "group_name",
          "checklist_name",
          "tipo_recorrencia",
          "status",
        ],
        sortIcon: {
          base: "fas",
          up: "fa-chevron-up",
          down: "fa-chevron-down",
          is: "fa-sort",
        },
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        orderBy: { column: "id", ascending: false },
        headings: {
          id: "ID",
          group_name: "Grupo/Usuário",
          checklist_name: "Checklist",
          tipo_recorrencia: "Recorrência",
          status: "Status",
          actions: "Ações",
        },
        texts: {
          filterBy: "Filtrar",
          defaultOption: "Selecione",
        },
        listColumns: {
          tipo_recorrencia: [
            { id: "daily", text: "Diária" },
            { id: "weekly", text: "Semanal" },
            { id: "monthly", text: "Mensal" },
          ],
          status: [
            { id: "ativo", text: "Ativo" },
            { id: "inativo", text: "Inativo" },
          ],
        },
        templates: {
          group_name: function (h, row) {
            // Se tiver usuario_id, mostrar o nome do usuário
            if (row.usuario && row.usuario.usuario_nome) {
              return row.usuario.usuario_nome;
            }
            // Senão, mostrar o nome do grupo
            if (row.group && row.group.group_nome) {
              return row.group.group_nome;
            }
            return "-";
          },
          checklist_name: function (h, row) {
            return row.checklist_template && row.checklist_template.nome
              ? row.checklist_template.nome
              : "-";
          },
          tipo_recorrencia: function (h, row) {
            if (row.tipo_recorrencia === "daily") return "Diária";
            if (row.tipo_recorrencia === "weekly") return "Semanal";
            if (row.tipo_recorrencia === "monthly") return "Mensal";
            return row.tipo_recorrencia || "-";
          },
          status: function (h, row) {
            if (row.status === "ativo") {
              return (
                <h5>
                  <span class="badge badge-primary">Ativo</span>
                </h5>
              );
            }

            if (row.status === "inativo") {
              return (
                <h5>
                  <span class="badge badge-danger">Inativo</span>
                </h5>
              );
            }

            return (
              <h5>
                <span class="badge badge-secondary">Desconhecido</span>
              </h5>
            );
          },
        },
        requestFunction: function (data) {
          let requestData = {};

          let query = this.$parent.$parent.$parent.query(data.query);
          requestData.params = data;
          requestData.params.query = "";

          return axios.get(this.url + "?" + query, requestData).catch(
            function (e) {
              this.dispatch("error", e);
            }.bind(this)
          );
        },
      },

      endPoint: "checklistschedules",

      dataForm: {},
    };
  },

  computed: {
    loggedUser() {
      return this.$store.state.auth?.user || this.$store.state.user || null;
    },

    isUsuarioPadraoLogged() {
      return Number(this.loggedUser?.perfil_id) === 2;
    },
  },

  methods: {
    query(query) {
      const columns = {
        id: "id",
        group_name: "group_id",
        checklist_name: "checklist_template_id",
        tipo_recorrencia: "tipo_recorrencia",
        status: "status",
      };

      let filters = "";

      $.each(query, function (index, value) {
        if (value !== null && value !== undefined && value !== "") {
          filters += columns[index] + "=" + value + "&";
        }
      });

      return filters;
    },
  },

  mounted() {
    if (this.isUsuarioPadraoLogged) {
      this.$message("Erro", "Você não tem permissão para acessar esta tela", "error");
      this.$router.push("/");
    }
  },
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}
</style>